import type { EchographyAdditionalQuestionRequestData } from '@common/validation/customControls/echography/echographyAdditionalQuestionRequest';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '../../customControlRegistry';
import { EchographyAdditionalQuestionRequestRead } from './EchographyAdditionalQuestionRequestRead';

const code = CustomControlCode.EchographyAdditionalQuestionRequest;

CustomControlRegistry.instance.register<EchographyAdditionalQuestionRequestData>({
    ReadElement: EchographyAdditionalQuestionRequestRead,
    code,
    version: 1,
});
